import { useSelector } from "react-redux";
import CompanyCard from "./CompanyCard";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useEffect, useState } from "react";

const CompanyCardList = ({}) => {
  const companyDatas = useSelector((state) => state.userDash.candidateData);
  const candidateInfo = useSelector((state) => state.userProfile.candidateInfo);

  const [mergedData, setMergedData] = useState(null);

  useEffect(() => {
    const mergedData = (companyDatas || []).map((companyData) => {
      const matchedData = (candidateInfo || []).find((candidateData) => candidateData.candidateId === companyData.candidateId);

      return {
        ...matchedData,
        ...companyData, // Ensure company data fields remain
        // Merge candidate info, but do not overwrite companyName
      };
    });

    setMergedData(mergedData);
  }, [companyDatas, candidateInfo]);

  return (
    <Row>
      {mergedData?.map((companyData, i) => {
        return (
          <Col md={12} xxl={6} xxxl={4} key={i} className={"mb-4"}>
            <CompanyCard companyData={companyData} />
          </Col>
        );
      })}
    </Row>
  );
};
export default CompanyCardList;
